/**
 * @generated SignedSource<<8b9221983102069e9494cf286350e49c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceScaffoldQuery$variables = {
  owner: string;
  slug: string;
};
export type WorkspaceScaffoldQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceVersionCloneButtonViewerFragment">;
  };
  readonly workspaceBySlug: {
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceScaffoldWorkspaceFragment">;
  } | null | undefined;
};
export type WorkspaceScaffoldQuery = {
  response: WorkspaceScaffoldQuery$data;
  variables: WorkspaceScaffoldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "owner"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "owner",
    "variableName": "owner"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*:: as any*/),
    (v6/*:: as any*/)
  ],
  "type": "Entity",
  "abstractKey": "__isEntity"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "private",
  "storageKey": null
},
v10 = [
  (v2/*:: as any*/),
  (v4/*:: as any*/),
  {
    "kind": "TypeDiscriminator",
    "abstractKey": "__isEntity"
  },
  (v5/*:: as any*/),
  (v6/*:: as any*/),
  (v3/*:: as any*/)
],
v11 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceScaffoldQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceVersionCloneButtonViewerFragment"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspaceBySlug",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceScaffoldWorkspaceFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "WorkspaceScaffoldQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserOrganizationConnection",
                "kind": "LinkedField",
                "name": "organizations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrganizationMembershipEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrganizationMembership",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organization",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": [
                              (v3/*:: as any*/),
                              (v4/*:: as any*/),
                              (v7/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*:: as any*/)
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspaceBySlug",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": (v10/*:: as any*/),
            "storageKey": null
          },
          {
            "alias": "latest",
            "args": (v11/*:: as any*/),
            "concreteType": "WorkspaceVersionConnection",
            "kind": "LinkedField",
            "name": "versions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkspaceVersionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkspaceVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/),
                      (v12/*:: as any*/),
                      (v13/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "latest",
                        "storageKey": null
                      },
                      {
                        "alias": "viewerCanEdit",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "action",
                            "value": "UPDATE_WORKSPACE_VERSION"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "viewerCan",
                        "storageKey": "viewerCan(action:\"UPDATE_WORKSPACE_VERSION\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Workspace",
                        "kind": "LinkedField",
                        "name": "workspace",
                        "plural": false,
                        "selections": [
                          (v3/*:: as any*/),
                          (v8/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "localSlug",
                            "storageKey": null
                          },
                          (v9/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              (v3/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v14/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "versions(first:1)"
          },
          {
            "alias": "latest",
            "args": (v11/*:: as any*/),
            "filters": null,
            "handle": "connection",
            "key": "WorkspaceScaffoldWorkspaceFragment_latest",
            "kind": "LinkedHandle",
            "name": "versions"
          },
          {
            "alias": "viewerCanEdit",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "UPDATE_WORKSPACE"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"UPDATE_WORKSPACE\")"
          },
          {
            "alias": "viewerCanCreateVersion",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "CREATE_WORKSPACE_VERSION"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"CREATE_WORKSPACE_VERSION\")"
          },
          {
            "alias": null,
            "args": (v11/*:: as any*/),
            "concreteType": "SubmissionConnection",
            "kind": "LinkedField",
            "name": "submissions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SubmissionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v14/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "submissions(first:1)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": "baseVersions",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 50
              }
            ],
            "concreteType": "WorkspaceVersionConnection",
            "kind": "LinkedField",
            "name": "versions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkspaceVersion",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v3/*:: as any*/),
                  (v12/*:: as any*/),
                  (v13/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "versions(first:50)"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "votes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "voterCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  }
                ],
                "concreteType": "VotersConnection",
                "kind": "LinkedField",
                "name": "voters",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v10/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "voters(first:10)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EntityVote",
                "kind": "LinkedField",
                "name": "voted",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "score",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "viewerCanVote",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "PUBLISH_VOTE"
                  }
                ],
                "kind": "ScalarField",
                "name": "viewerCan",
                "storageKey": "viewerCan(action:\"PUBLISH_VOTE\")"
              }
            ],
            "type": "Votable",
            "abstractKey": "__isVotable"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "74548d94e75178a20d256dae0f0bbd36",
    "id": null,
    "metadata": {},
    "name": "WorkspaceScaffoldQuery",
    "operationKind": "query",
    "text": "query WorkspaceScaffoldQuery(\n  $owner: String!\n  $slug: String!\n) {\n  viewer @ifAllowed {\n    __typename\n    ...WorkspaceVersionCloneButtonViewerFragment\n    id\n  }\n  workspaceBySlug(owner: $owner, slug: $slug) {\n    ...WorkspaceScaffoldWorkspaceFragment\n    id\n  }\n}\n\nfragment EntitiesAvatarFragment on VotersConnection {\n  edges {\n    node {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment VoteDisplayFragment on Votable {\n  __isVotable: __typename\n  id\n  votes\n  voterCount\n  voters(first: 10) {\n    ...EntitiesAvatarFragment\n  }\n  voted @ifAllowed {\n    score\n  }\n  viewerCanVote: viewerCan(action: PUBLISH_VOTE)\n}\n\nfragment WorkspacePublishButtonFragment on Workspace {\n  id\n  viewerCanCreateVersion: viewerCan(action: CREATE_WORKSPACE_VERSION)\n  baseVersions: versions(first: 50) {\n    nodes {\n      id\n      version\n      publishedAt\n    }\n  }\n}\n\nfragment WorkspaceScaffoldVersionFragment on WorkspaceVersion {\n  id\n  version\n  publishedAt\n  latest\n  viewerCanEdit: viewerCan(action: UPDATE_WORKSPACE_VERSION)\n  ...WorkspaceVersionCloneButtonVersionFragment\n}\n\nfragment WorkspaceScaffoldWorkspaceFragment on Workspace {\n  id\n  name\n  slug\n  private\n  owner {\n    __typename\n    username\n    ...EntityProfilePicFragment_49kWkb\n    id\n  }\n  latest: versions(first: 1) {\n    edges {\n      node {\n        ...WorkspaceScaffoldVersionFragment\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  viewerCanEdit: viewerCan(action: UPDATE_WORKSPACE)\n  viewerCanCreateVersion: viewerCan(action: CREATE_WORKSPACE_VERSION)\n  submissions(first: 1) {\n    edges {\n      cursor\n    }\n  }\n  ...VoteDisplayFragment\n  ...WorkspaceVersionHistoryFragment\n  ...WorkspacePublishButtonFragment\n}\n\nfragment WorkspaceVersionCloneButtonVersionFragment on WorkspaceVersion {\n  id\n  version\n  workspace {\n    id\n    slug\n    localSlug\n    private\n    owner {\n      __typename\n      id\n    }\n  }\n}\n\nfragment WorkspaceVersionCloneButtonViewerFragment on User {\n  id\n  username\n  ...EntityProfilePicFragment_49kWkb\n  organizations {\n    edges {\n      node {\n        organization {\n          id\n          username\n          ...EntityProfilePicFragment_49kWkb\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment WorkspaceVersionHistoryFragment on Workspace {\n  id\n  slug\n  createdAt\n  ...WorkspacePublishButtonFragment\n}\n"
  }
};
})();

(node as any).hash = "fb1024d76057a948ead982b05dd969cb";

export default node;
